import { useSiteContext } from '3-foundation/Site/SiteContext';
import { LanguageLink, UI_LanguageSelector } from 'ui/components/3-organisms/LanguageSelector/LanguageSelector';
import { useState, useEffect } from 'react';
import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';
import { LanguageKey } from '3-foundation/Dictionary/groups/LanguageItems';
import { useApplicationContext } from '3-foundation/Application/ApplicationContext';
import { useRouter } from 'next/router';
import { usePageContext } from '3-foundation/PageContent/PageContext';

export const LanguageSelector = () => {
	const siteContext = useSiteContext();
	const pageContext = usePageContext();
	const dictionary = useDictionaryContext();
	const application = useApplicationContext();
	const { locale } = useRouter();
	const { settings, locales } = siteContext ?? {};
	const { useDefaultSelector, additionalLinks } = settings?.languages ?? {};
	const [languageLinks, setLanguageLinks] = useState<LanguageLink[]>(null);
	const [currentName, setCurrentName] = useState(null);

	useEffect(() => {
		const getCultureUrl = (localeKey: string): string => {
			const culture = pageContext?.cultures?.find((c) => c[localeKey]);
			return culture?.[localeKey]?.url ?? `/${localeKey.toLowerCase()}`;
		};

		const localeLinks = Object.keys(locales)
			.map((key) => ({
				name: dictionary.getLanguage(key.toUpperCase() as LanguageKey),
				url: getCultureUrl(key),
			}))
			.filter(Boolean);

		const mappedAdditionalLinks = additionalLinks?.map((link) => ({ name: link.title, url: link.url })) ?? [];

		const links = useDefaultSelector ? [...localeLinks, ...mappedAdditionalLinks] : [...mappedAdditionalLinks];
		const order = ['kl-gl', 'da', 'en'];
		const sortedLinks = order.map((locale) => links.find((l) => l.url.toLowerCase().startsWith(`/${locale}`))).filter(Boolean);
		setLanguageLinks(sortedLinks);
	}, [additionalLinks, dictionary, locales, useDefaultSelector, pageContext?.cultures]);

	useEffect(() => {
		if (!languageLinks || !locale) return;
		const currentLanguageLink = languageLinks.find((link) => link.url.toLowerCase().startsWith(`/${String(locale).toLowerCase()}`));
		if (currentLanguageLink) setCurrentName(currentLanguageLink.name);
	}, [languageLinks, application, locale]);
	if (!languageLinks || languageLinks.length < 1 || !currentName) return null;
	return <UI_LanguageSelector links={languageLinks} currentLinkName={currentName} />;
};
